var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:12;stroke-miterlimit:10;}\r\n\t.st1{stroke:#000000;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#000000;stroke-width:12;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -53.2265 128.5)",
    className: "st0",
    cx: 128.5,
    cy: 128.5,
    rx: 118.5,
    ry: 118.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.6,100.9c0-5.8,4.7-10.5,10.5-10.5c5.8,0,10.5,4.7,10.5,10.5c0,5.8-4.7,10.5-10.5,10.5 C69.3,111.4,64.6,106.7,64.6,100.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M171.4,100.9c0-5.8,4.7-10.5,10.5-10.5c5.8,0,10.5,4.7,10.5,10.5c0,5.8-4.7,10.5-10.5,10.5 C176.1,111.4,171.4,106.7,171.4,100.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M192.2,148.3c-8.4,27.2-33.8,46.9-63.7,46.9c-29.9,0-55.3-19.7-63.7-46.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 69.8,
    y1: 145.4,
    x2: 57.7,
    y2: 151.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 187.2,
    y1: 145.4,
    x2: 199.3,
    y2: 151.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy);
export default __webpack_public_path__ + "static/media/Happy.465a501f4cdd606bd977e93d6fc59446.svg";
export { ForwardRef as ReactComponent };